export default class GeoPoint {
    lng = 0
    lat = 0;
}